import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ErrorHandlingService } from '../../../services/error-handling/error-handling.service';
import { HttpHeaderConstants } from '../../../services/http-header.constant';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class WebhookConnectorTableService {
    readonly #errorHandlingService = inject(ErrorHandlingService);
    readonly #http = inject(HttpClient);

    private TABLE_URL: string = environment.publicApiHost + '/appcloud/webhook-connector/tables';

    create(appinstanceId: number, additionalHeaders: any = {}): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
            params: new HttpParams().set('appinstanceId', appinstanceId.toString()),
        };

        return this.#http.post(this.TABLE_URL, null, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(error, false, 'An error occurred. Please try again later.');
                return of<any>();
            }),
            finalize(() => {})
        );
    }

    delete(appinstanceId: number, additionalHeaders: any = {}): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
            params: new HttpParams().set('appinstanceId', appinstanceId.toString()),
        };

        return this.#http.delete(this.TABLE_URL, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred during the deletion process. Please try again later.'
                );
                return of<any>();
            }),
            finalize(() => {})
        );
    }
}
